import { useId } from "react";
import { IRadioButton } from "../../interfaces";

export const GaRadioButton = ({ label, value, selectedValue, onChange, disabled }: IRadioButton) => {
    const id = useId();

    return (
        <label className="ga-radio-button" htmlFor={id}>
            <input 
                type="radio"
                id={id}
                className="ga-radio-button__native"
                value={value}
                checked={value === selectedValue}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
            />
            <div className="ga-radio-button__marker"></div>
            <div className="ga-radio-button__label">{label}</div>
      </label>
    );
};
